import { render } from "./spinLoader.vue?vue&type=template&id=6323e57e&scoped=true"
import script from "./spinLoader.vue?vue&type=script&lang=js"
export * from "./spinLoader.vue?vue&type=script&lang=js"

import "./spinLoader.vue?vue&type=style&index=0&id=6323e57e&lang=scss&scoped=true"

import exportComponent from "D:\\Epaylater Projects\\microapp-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6323e57e"]])

export default __exports__